<template>
  <div class="login">
    <van-loading size="3.2rem" vertical>登录中...</van-loading>
  </div>
</template>
<script>
export default {
  name: "login",
  mounted() {
    this.$router.push({
      name: "friend",
    });
  },
};
</script>
<style lang="less" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: #fff;
}
</style>